import { shape, string } from 'prop-types';
import MomentType from 'types/commons/MomentType';

export default shape({
    from: MomentType.isRequired,
    to: MomentType.isRequired,
    type: string.isRequired,
});
